import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "./basket-navigation.module.css";
import { useContext, useState, useEffect } from "react";
import { SharedUiHeaderV2Context } from "../../context/context-shared-ui-header-v2";
import { TimeIcon } from "../../../assets/time";
import cx from "classnames";
import { useExpiry } from "../../hooks/use-expiry";
import { BasketComponent } from "./basket-component";
import { BasketIconWrapper } from "./basket-icon-wrapper";
export const BasketNavigation = ({ checkoutModalAvailable , shouldShowBasketIcon  })=>{
    const { userStore , logicStore  } = useContext(SharedUiHeaderV2Context);
    const [isInCheckoutJourney, setIsInCheckoutJourney] = useState(false);
    const [shouldShowExpiringOrExpired, setShouldShowExpiringOrExpired] = useState(false);
    const { isLoggedIn , activeOrder , refreshActiveOrder  } = userStore;
    const { isCheckoutModalVisible , setIsCheckoutModalVisible  } = logicStore;
    /* Times needed to calculate which icon to show*/ const warningTime = 5 * 60 * 1000;
    const timeNow = Math.floor(Date.now());
    const orderHasExpired = ((activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ?? 0) < timeNow;
    const isExpiringSoon = (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) ? warningTime + timeNow > (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) : null;
    useEffect(()=>{
        if ("object" !== "undefined") {
            const { pathname  } = window.location;
            const regex = /checkout/;
            setIsInCheckoutJourney(regex.test(pathname));
            /* This needs to wrap the refreshActiveOrder to
       * ensure we wait for the activeOrder to be populated
       */ const refreshActiveOrderData = async ()=>{
                if (isLoggedIn) {
                    await refreshActiveOrder();
                }
            };
            refreshActiveOrderData();
        }
    }, [
        isLoggedIn
    ]);
    useExpiry(activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt, setShouldShowExpiringOrExpired, timeNow, warningTime, !!(orderHasExpired || isExpiringSoon));
    const isBasketVisible = isLoggedIn && (activeOrder === null || activeOrder === void 0 ? void 0 : activeOrder.expiresAt) && shouldShowBasketIcon && isInCheckoutJourney === false;
    const isExpiringOrExpiredBasket = isBasketVisible && shouldShowExpiringOrExpired === true;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isExpiringOrExpiredBasket && /*#__PURE__*/ _jsx(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: ()=>{
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: cx(styles.timerIcon, styles.pulse),
                            children: /*#__PURE__*/ _jsx(TimeIcon, {})
                        }),
                        /*#__PURE__*/ _jsx(BasketIconWrapper, {})
                    ]
                })
            }),
            isBasketVisible && !isExpiringOrExpiredBasket && /*#__PURE__*/ _jsx(BasketComponent, {
                tag: checkoutModalAvailable === true ? "button" : "a",
                setShouldShowCheckoutModal: ()=>{
                    setIsCheckoutModalVisible && setIsCheckoutModalVisible(!isCheckoutModalVisible);
                },
                children: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: styles.number,
                            children: "1"
                        }),
                        /*#__PURE__*/ _jsx(BasketIconWrapper, {})
                    ]
                })
            })
        ]
    });
};
